var map = {
	"./icons/telegram.svg": "14ac",
	"./lottie/error": "22b7",
	"./lottie/error.json": "22b7",
	"./lottie/event": "8d7b",
	"./lottie/event.json": "8d7b",
	"./lottie/fire": "14eb",
	"./lottie/fire.json": "14eb",
	"./lottie/paper": "a1e2",
	"./lottie/paper.json": "a1e2",
	"./lottie/ton": "f61a",
	"./lottie/ton.json": "f61a",
	"./lottie/wait": "16ee",
	"./lottie/wait.json": "16ee",
	"./lottie/wallet": "d967",
	"./lottie/wallet.json": "d967",
	"./lottie/win": "1cc4",
	"./lottie/win.json": "1cc4",
	"./wallet/ui/arrow.svg": "4860",
	"./wallet/ui/close-black.svg": "12ad",
	"./wallet/ui/close.svg": "531b",
	"./wallet/ui/down-left-white.svg": "b460",
	"./wallet/ui/down-left.svg": "bfee",
	"./wallet/ui/menu.svg": "c063",
	"./wallet/ui/refresh.svg": "5ee1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";